export const HEATMAP_MEASUREMENTS_ACTION = {
  GET_MEASUREMENTS: 'HEATMAP_MEASUREMENTS.GET_MEASUREMENTS',
  GET_MEASUREMENTS_SUCCESS: 'HEATMAP_MEASUREMENTS.GET_MEASUREMENTS_SUCCESS',
  GET_MEASUREMENTS_FAILED: 'HEATMAP_MEASUREMENTS.GET_MEASUREMENTS_FAILED',

  DELETE_MEASUREMENT: 'HEATMAP_MEASUREMENTS.DELETE_MEASUREMENT',
  DELETE_MEASUREMENT_SUCCESS: 'HEATMAP_MEASUREMENTS.DELETE_MEASUREMENT_SUCCESS',
  DELETE_MEASUREMENT_FAILED: 'HEATMAP_MEASUREMENTS.DELETE_MEASUREMENT_FAILED',

  GET_MEASUREMENT_DETAILS: 'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_DETAILS',
  GET_MEASUREMENT_DETAILS_SUCCESS:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_DETAILS_SUCCESS',
  GET_MEASUREMENT_DETAILS_FAILED:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_DETAILS_FAILED',

  ADD_MEASUREMENT: 'HEATMAP_MEASUREMENTS.ADD_MEASUREMENT',
  ADD_MEASUREMENT_SUCCESS: 'HEATMAP_MEASUREMENTS.ADD_MEASUREMENT_SUCCESS',
  ADD_MEASUREMENT_FAILED: 'HEATMAP_MEASUREMENTS.ADD_MEASUREMENT_FAILED',

  GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS',
  GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_SUCCESS:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_SUCCESS',
  GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_FAILED:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_FAILED',

  HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS',
  HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_SUCCESS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_SUCCESS',
  HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_FAILED:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_FAILED',

  HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS',
  HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_SUCCESS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_SUCCESS',
  HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_FAILED:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_FAILED',

  HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS',
  HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_SUCCESS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_SUCCESS',
  HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_FAILED:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_FAILED',

  HEATMAP_MEASUREMENT_CUSTOMER_LOGIN:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_CUSTOMER_LOGIN',
  HEATMAP_MEASUREMENT_CUSTOMER_LOGIN_SUCCESS:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_CUSTOMER_LOGIN_SUCCESS',
  HEATMAP_MEASUREMENT_CUSTOMER_LOGIN_FAILED:
    'HEATMAP_MEASUREMENTS.HEATMAP_MEASUREMENT_CUSTOMER_LOGIN_FAILED',

  DATA_SHARING_CUSTOMER_LOGIN: 'DATA_SHARING_CUSTOMER_LOGIN',
  DATA_SHARING_CUSTOMER_LOGIN_SUCCESS: 'DATA_SHARING_CUSTOMER_LOGIN_SUCCESS',
  DATA_SHARING_CUSTOMER_LOGIN_ERROR: 'DATA_SHARING_CUSTOMER_LOGIN_ERROR',

  GENERATE_HEATMAP_MEASUREMENT_DATA_URL:
    'GENERATE_HEATMAP_MEASUREMENT_DATA_URL',
  GENERATE_HEATMAP_MEASUREMENT_DATA_URL_SUCCESS:
    'GENERATE_HEATMAP_MEASUREMENT_DATA_URL_SUCCESS',
  GENERATE_HEATMAP_MEASUREMENT_DATA_URL_ERROR:
    'GENERATE_HEATMAP_MEASUREMENT_DATA_URL_ERROR',

  UPDATE_MEASUREMENT_SETTINGS:
    'HEATMAP_MEASUREMENTS.UPDATE_MEASUREMENT_SETTINGS',
  UPDATE_MEASUREMENT_SETTINGS_SUCCESS:
    'HEATMAP_MEASUREMENTS.UPDATE_MEASUREMENT_SETTINGS_SUCCESS',
  UPDATE_MEASUREMENT_SETTINGS_FAILED:
    'HEATMAP_MEASUREMENTS.UPDATE_MEASUREMENT_SETTINGS_FAILED',

  GET_MEASUREMENT_AREAS: 'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREAS',
  GET_MEASUREMENT_AREAS_SUCCESS:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREAS_SUCCESS',
  GET_MEASUREMENT_AREAS_FAILED:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREAS_FAILED',

  GET_MEASUREMENT_AREA_DETAILS:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREA_DETAILS',
  GET_MEASUREMENT_AREA_DETAILS_SUCCESS:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREA_DETAILS_SUCCESS',
  GET_MEASUREMENT_AREA_DETAILS_FAILED:
    'HEATMAP_MEASUREMENTS.GET_MEASUREMENT_AREA_DETAILS_FAILED',

  SAVE_MEASUREMENT_AREA_SETTINGS:
    'HEATMAP_MEASUREMENTS.SAVE_MEASUREMENT_AREA_SETTINGS',
  SAVE_MEASUREMENT_AREA_SETTINGS_SUCCESS:
    'HEATMAP_MEASUREMENTS.SAVE_MEASUREMENT_AREA_SETTINGS_SUCCESS',
  SAVE_MEASUREMENT_AREA_SETTINGS_FAILED:
    'HEATMAP_MEASUREMENTS.SAVE_MEASUREMENT_AREA_SETTINGS_FAILED',

  GET_HEATMAP_MEASUREMENT_CSV_DATA:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_CSV_DATA',
  GET_HEATMAP_MEASUREMENT_CSV_DATA_SUCCESS:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_CSV_DATA_SUCCESS',
  GET_HEATMAP_MEASUREMENT_CSV_DATA_FAILED:
    'HEATMAP_MEASUREMENTS.GET_HEATMAP_MEASUREMENT_CSV_DATA_FAILED',

  ADD_NODE: 'ADD_NODE',
  DELETE_NODE: 'DELETE_NODE',
  SET_NODES: 'SET_NODES',
  SET_NODE_POSITIONS: 'SET_NODE_POSITIONS',
};

export const getHeatmapMeasurements = () => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS,
});

export const deleteHeatmapMeasurement = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT,
  payload: data,
  callbackFn: callbackFn,
});

export const getHeatmapMeasurementDetails = (measId) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS,
  measId,
});

export const addHeatmapMeasurement = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT,
  payload: data,
  callbackFn: callbackFn,
});

export const updateHeatmapMeasurementSettings = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS,
  payload: data,
  callbackFn: callbackFn,
});

export const getHeatmapMeasurementAccessEmails = (measId, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS,
  measId,
  callbackFn: callbackFn,
});

export const addAccessEmailsToHeatmapMeasurement = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS,
  payload: data,
  callbackFn: callbackFn,
});

export const updateAccessStatusOfHeatmapMeasurement = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS,
  payload: data,
  callbackFn: callbackFn,
});

export const deleteAllEmailAccessOfHeatmapMeasurement = (
  measId,
  callbackFn
) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS,
  measId,
  callbackFn: callbackFn,
});

export const heatmapMeasurementCustomerLogin = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_CUSTOMER_LOGIN,
  payload: data,
  callbackFn: callbackFn,
});

export const heatmapCustomerLogin = (data, callbackFn) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN,
  payload: data,
  callbackFn: callbackFn,
});
export const getHeatmapMeasurementAreas = (measId) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS,
  measId,
});

export const getHeatmapMeasurementAreaDetails = (measId, areaNo) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS,
  payload: { measId, areaNo },
});

export const saveHeatmapMeasurementAreaSettings = (data) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS,
  payload: data,
});

export const getHeatmapMeasurementCSVData = (areaNo, dataFileURL) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA,
  payload: { areaNo, dataFileURL },
});

// =========================================================================
export const addNode = (data, callback = () => {}) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.ADD_NODE,
  payload: data,
  callback,
});

// =========================================================================
export const deleteNode = (data, callback = () => {}) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.DELETE_NODE,
  payload: data,
  callback,
});

// =========================================================================
export const setNodes = (data, callback = () => {}) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.SET_NODES,
  payload: data,
  callback,
});

// =========================================================================
export const setNodePositions = (data, callback = () => {}) => ({
  type: HEATMAP_MEASUREMENTS_ACTION.SET_NODE_POSITIONS,
  payload: data,
  callback,
});
